import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=115a431d"
import script from "./Poster.vue?vue&type=script&lang=js"
export * from "./Poster.vue?vue&type=script&lang=js"
import style0 from "./Poster.vue?vue&type=style&index=0&id=115a431d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports